/**
 * SAP CONFIDENTIAL 
 *
 * This software is confidential proprietary software licensed by SAP SE 
 * and is not to be used, duplicated or disclosed to anyone without the 
 * prior written permission of SAP. 
 *
 * (C) 2020 Copyright SAP SE.
 */
/**
 * Created by RajeshCherukuri on 10/12/17.
 */

import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';

@Injectable()
export class CalendarService {
  private environmentUrl: string = environment.host;
  private url: string = environment.host + '/period';
  private periodDefUrl: string = environment.host + '/calendarDefinition';
  private quarterDefUrl: string = environment.host + '/quarterDefinition';
  private periodDefAnnualUrl: string = environment.host + '/annualCalendar';
  private companyUrl: string = environment.host + '/company?tabType=' + 'CAL';
  private companyUrlTabType: string = environment.host + '/company/';

  constructor(private http: HttpClient) { }

  public getCalendarPeriods(region: any) {
    if (region) {
      return this.http.get(this.url + '?companyCode=' + region).toPromise();
    } else {
      return this.http.get(this.url.toString()).toPromise();
    }
  }

  public getCompanyGenConfigurationTabType(companyId: any) {
    return this.http.get(this.companyUrlTabType.toString() + companyId + '/configuration?tabType=' + 'lineageconfiguration/calender').toPromise();
  }

  public getPlanPeriods(region: any) {
    if (region) {
      return this.http.get(this.periodDefUrl + '?companyCode=' + region).toPromise();
    } else {
      return this.http.get(this.periodDefUrl.toString()).toPromise();
    }
  }

  public getPlanPeriodsTabTypes(region: any) {
    if (region) {
      return this.http.get(this.periodDefUrl + '?companyCode=' + region + '&tabType=' + 'planperiodview').toPromise();
    } else {
      return this.http.get(this.periodDefUrl.toString() + '?tabType=' + 'planperiodview').toPromise();
    }
  }

  public postPlanPeriods(region: any, payload: any) {
    if (region) {
      return this.http.post(this.periodDefUrl + '?companyCode=' + region, payload).toPromise();
    } else {
      return this.http.post(this.periodDefUrl.toString(), payload).toPromise();
    }
  }

  putPlanPeriods(region: any, payload: any) {
    if (region) {
      return this.http.put(this.periodDefUrl + '?companyCode=' + region, payload).toPromise();
    } else {
      return this.http.put(this.periodDefUrl.toString(), payload).toPromise();
    }
  }

  public postAnnualPlanPeriods(region: any, payload: any) {
    if (region) {
      return this.http.post(this.periodDefAnnualUrl + '?companyCode=' + region, payload).toPromise();
    } else {
      return this.http.post(this.periodDefAnnualUrl.toString(), payload).toPromise();
    }
  }

  public getAnnualPlanPeriods(region: any) {
    if (region) {
      return this.http.get(this.periodDefAnnualUrl + '?companyCode=' + region).toPromise();
    } else {
      return this.http.get(this.periodDefAnnualUrl.toString()).toPromise();
    }
  }

  public putAnnualPlanPeriods(region: any, year: any, payload: any) {
    if (region) {
      return this.http.put(this.periodDefAnnualUrl + '/' + year + '?companyCode=' + region, payload).toPromise();
    } else {
      return this.http.put(this.periodDefAnnualUrl + '/' + year, payload).toPromise();
    }
  }

  public getAnnualYearPlanPeriods(region: any, year: any) {
    if (region) {
      return this.http.get(this.url + '/' + year + '?regionCode=' + region).toPromise();
    } else {
      return this.http.get(this.url + '/' + year).toPromise();
    }
  }

  // getCampaigns(region) {
  //   if (region) {
  //     return this.http.get(this.environmentUrl + '/periodsegmentdef' + '?regionCode=' + region).toPromise();
  //   } else {
  //     return this.http.get(this.environmentUrl + '/periodsegmentdef').toPromise();
  //   }
  // }

  // getCampaignsByName(region, name) {
  //   if (region) {
  //     return this.http.get(this.environmentUrl + '/periodsegmentdef/' + name + '?regionCode=' + region).toPromise();
  //   } else {
  //     return this.http.get(this.environmentUrl + '/periodsegmentdef/' + name).toPromise();
  //   }
  // }

  // postCampaigns(region, payload) {
  //   if (region) {
  //     return this.http.post(this.environmentUrl + '/periodsegmentdef' + '?regionCode=' + region, payload).toPromise();
  //   } else {
  //     return this.http.post(this.environmentUrl + '/periodsegmentdef', payload).toPromise();
  //   }
  // }

  // putCampaigns(region, payload) {
  //   if (region) {
  //     return this.http.put(this.environmentUrl + '/periodsegmentdef' + '?regionCode=' + region, payload).toPromise();
  //   } else {
  //     return this.http.put(this.environmentUrl + '/periodsegmentdef', payload).toPromise();
  //   }
  // }


  public getPeriodObj() {
    const currentYear = new Date().getFullYear();
    let inputParams = {};
    return inputParams = {
      "name": currentYear,
      "totalPeriods": 12,
      "type": "YEAR",
      "planId": 1,
      "periodCode": currentYear,
      "periods": [
        {
          "name": currentYear + "01",
          "type": "MONTH"
        },
        {
          "name": currentYear + "02",
          "type": "MONTH"
        },
        {
          "name": currentYear + "03",
          "type": "MONTH"
        },
        {
          "name": currentYear + "04",
          "type": "MONTH"
        },
        {
          "name": currentYear + "05",
          "type": "MONTH"
        },
        {
          "name": currentYear + "06",
          "type": "MONTH"
        },
        {
          "name": currentYear + "07",
          "type": "MONTH"
        },
        {
          "name": currentYear + "08",
          "type": "MONTH"
        },
        {
          "name": currentYear + "09",
          "type": "MONTH"
        },
        {
          "name": currentYear + "10",
          "type": "MONTH"
        },
        {
          "name": currentYear + "11",
          "type": "MONTH"
        },
        {
          "name": currentYear + "12",
          "type": "MONTH"
        }
      ]
    };
  }

  public getPeriodYearObj(year: any, periodLength: any) {
    const currentYear = year;
    let inputParams: any = {};
    inputParams = {
      "name": currentYear,
      "totalPeriods": periodLength,
      "type": "YEAR",
      "planId": 1,
      "periodCode": currentYear,
      periods: []
    };
    let periodObj: any = {};
    for (let i = 1; i <= periodLength; i++) {
      periodObj = {};
      if (i < 10) {
        periodObj.name = currentYear + "0" + i;
      } else {
        periodObj.name = currentYear + i;
      }
      periodObj.type = 'MONTH';
      inputParams.periods.push(JSON.parse(JSON.stringify(periodObj)));
    }
    return inputParams;
  }

  public createPlanPeriods(region: any) {
    if (region) {
      return this.http.post(this.url + '?regionCode=' + region, this.getPeriodObj()).toPromise();
    } else {
      return this.http.post(this.url.toString(), this.getPeriodObj()).toPromise();
    }
  }

  public createYearPlanPeriods(region: any, year: any, periodLength: any) {
    if (region) {
      return this.http.post(this.url + '?regionCode=' + region, this.getPeriodYearObj(year, periodLength)).toPromise();
    } else {
      return this.http.post(this.url.toString(), this.getPeriodObj()).toPromise();
    }
  }

  public getPlanPeriod(regCode?: string) {
    if (regCode) {
      return this.http.get(this.environmentUrl.toString() + '/period?regionCode=' + regCode).toPromise();
    } else {
      return this.http.get(this.environmentUrl.toString() + '/period').toPromise();
    }
  }

  public getCommisionRunDetails(periodName: any, reg: any) {
    if (reg) {
      return this.http.get(this.environmentUrl.toString() + '/period/' + periodName + '?regionCode=' + reg).toPromise();
    } else {
      return this.http.get(this.environmentUrl.toString() + '/period/' + periodName).toPromise();
    }
  }

  public updatePlanPeriodTabDetails(periodName: any, reg: any, requestPayload: any) {
    if (reg) {
      return this.http.put(this.environmentUrl.toString() + '/period/' + periodName + '?regionCode=' + reg, requestPayload).toPromise();
    } else {
      return this.http.put(this.environmentUrl.toString() + '/period/' + periodName, requestPayload).toPromise();
    }
  }

  public getQuarterCalendar() {
    return this.http.get(this.quarterDefUrl.toString() + '/quarters').toPromise();
  }

  public createQuarterCalendar(region: any, payload: any) {
    if (region) {
      return this.http.post(this.quarterDefUrl + '/quarter'+ '?companyCode=' + region, payload).toPromise();
    } else {
      return this.http.post(this.quarterDefUrl.toString(), payload).toPromise();
    }
  }

  public uploadAnnualCalendarFile(formData: any, region: any) {
    const url = environment.host + '/uploadAnnualCalendar'+ '?companyCode=' + region;
    return this.http.post(url, formData).toPromise();    
  }

  public getAllCompanies() {
    return this.http.get(this.companyUrl.toString()).toPromise();
  }
}
